// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './styles.css';
// import Landing from './Landing';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Landing />
//   </React.StrictMode>
// );

import { createRoot } from 'react-dom/client'
import './styles.css'
import Landing from './Landing'

createRoot(document.getElementById('root')).render(<Landing />)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
